import React, { FC } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { InjectedBreakpointsProps, withBreakpoints } from 'react-match-breakpoints';

import { i18n } from 'app/i18n';
import arrowLeft from 'app/resources/arrow-left.svg';
import { NavigationService, navigationService } from 'app/service/navigation-service';
import { BreadcrumbUtils } from 'app/utils/breadcrumb-utils';
import { Typography } from 'app/components/common/typography';
import { Button } from 'app/components/common/buttons';
import { Image } from 'app/components/common/image';
import { SmallContainer } from 'app/components/common/container';
import { BreakpointsUtils } from 'app/utils/breakpoints-utils';

import styles from './breadcrumb.module.scss';

interface OwnProps {
    hasAppointment: boolean;
}

type Props = OwnProps & InjectedBreakpointsProps;

const BreadcrumbComponent: FC<Props> = (props) => {
    const { breakpoints, hasAppointment } = props;

    const { pathname } = useLocation();
    const { externalBreadcrumbs, internalBreadcrumbs } = BreadcrumbUtils.getBreadcrumbs(pathname, hasAppointment);

    const goToPreviousStep = () => {
        navigationService.goToPath(BreadcrumbUtils.getPreviousBreadcrumbPath(pathname, internalBreadcrumbs));
    };

    const renderMobileBreadcrumbItems = () =>
        NavigationService.SUMMARY === pathname ? null : (
            <Button type="link" submitting={false} onClick={goToPreviousStep} className={styles.button}>
                <div className={styles.imageContainer}>
                    <Image src={arrowLeft} alt={i18n.image.arrowLeft} />
                </div>
                {i18n.components.breadcrumb.back}
            </Button>
        );

    const renderDesktopBreadcrumbItems = () => (
        <>
            {externalBreadcrumbs.map((breadcrumb, index) => (
                <div className={styles.linkContainer} key={index}>
                    <a href={breadcrumb.path} className={styles.link}>
                        {breadcrumb.text}
                    </a>
                </div>
            ))}
            {internalBreadcrumbs.map((breadcrumb, index) => (
                <div className={styles.linkContainer} key={index}>
                    {internalBreadcrumbs.length - 1 === index ? (
                        <Typography variant="body1" className={styles.text}>
                            {breadcrumb.text}
                        </Typography>
                    ) : (
                        <Link to={breadcrumb.path} className={styles.link}>
                            {breadcrumb.text}
                        </Link>
                    )}
                </div>
            ))}
        </>
    );

    return (
        <div className={styles.breadcrumb}>
            <SmallContainer additionalStyles={styles.container}>
                {BreakpointsUtils.isOnMobile(breakpoints)
                    ? renderMobileBreadcrumbItems()
                    : renderDesktopBreadcrumbItems()}
            </SmallContainer>
        </div>
    );
};

export const Breadcrumb = withBreakpoints(BreadcrumbComponent);
